import { useTranslation } from 'react-i18next';

import useFetchTrigger from 'components/domain/automation/triggers/useFetchTrigger';
import LoadingPlaceholder from 'components/loader/LoadingPlaceholder';

interface TriggerEventTypeProps {
  triggerUid: string | null;
}

const TriggerEventType = ({ triggerUid }: TriggerEventTypeProps) => {
  const { t } = useTranslation();
  const { data: trigger, isLoading } = useFetchTrigger({ triggerUid });

  if (isLoading) {
    <LoadingPlaceholder />;
  }

  if (!trigger) {
    return '-';
  }

  return t('pageAutomations.triggers.eventType', {
    context: trigger?.eventType,
  });
};

export default TriggerEventType;
